export default "__VITE_ASSET__M5XzWt7n__"